import {observer} from 'mobx-react'
import React, {Component, Fragment} from 'react'
import styled from 'styled-components'
import Input from '../../components/Input'
import Row from '../../components/Row'
import Select from '../../components/Select'
import patient from '../../stores/patient'
import Text from "../../components/Text";


const AddMonitorButton = styled.button`
  background: transparent;
  color: var(--blue);
  cursor: pointer;
  width: 100%;
  font-size: 0.9rem;
  text-align: left;
  &:hover {
    color: var(--green);
  }
`

const DeleteMonitorButton = styled.button`
    background: transparent;
    color: var(--light-red);
    cursor: pointer;
    width: 100%;
    font-size: 0.9rem;
    text-align: left;
    &:hover {
        color: var(--red);
    }
`
function getDisabledValues() {
  const arr = []
  
  for (const medication of patient.fields.medications) {
    arr.push(medication.prescription)
  }

  return arr
}

@observer
export default class MedicationForm extends Component {
  render() {
    const {prescription, eye, frequency, monitors,
      allowEmptyValues, onChange, medicationIndex,
      prescriptionStartDate, prescriptionEndDate, hideMonitor,
      allMonitors, assignedMonitors,
    } = this.props
    const disabledChoices = getDisabledValues()
    return (
      <Fragment>
        <Select
          value={prescription}
          label="titles.prescription"
          name="prescription"
          onChange={onChange}
        >
          {allowEmptyValues && <option value=""/>}
          <Select.Options
            choices="purpleMedication"
            disabledChoices={disabledChoices}
            label="titles.purpleMedication"
          />
          <Select.Options
            choices="yellowMedication"
            disabledChoices={disabledChoices}
            label="titles.yellowMedication"
          />
          <Select.Options
            choices="orangeMedication"
            disabledChoices={disabledChoices}
            label="titles.orangeMedication"
          />
          <Select.Options
            choices="darkBlueMedication"
            disabledChoices={disabledChoices}
            label="titles.darkBlueMedication"
          />
          <Select.Options
            choices="darkGreenMedication"
            disabledChoices={disabledChoices}
            label="titles.darkGreenMedication"
          />
          <Select.Options
            choices="tealMedication"
            disabledChoices={disabledChoices}
            label="titles.tealMedication"
          />
          <Select.Options
            choices="whiteMedication"
            disabledChoices={disabledChoices}
            label="titles.whiteMedication"
          />
          <Select.Options
            choices="otherMedication"
            disabledChoices={disabledChoices}
            label="titles.otherMedication"
          />
        </Select>
        <Row>
          <Row.Cell>
            <Select
              label="titles.eye"
              value={eye}
              name="eye"
              onChange={onChange}
            >
              {allowEmptyValues && <option value=""/>}
              <Select.Options choices="eye"/>
            </Select>
          </Row.Cell>
          <Row.Cell>
            <Input
              label="titles.frequency"
              value={frequency}
              name="frequency"
              onChange={onChange}
            />
          </Row.Cell>
        </Row>
        <Row>
          <Row.Cell>
            <Input type="date" label="titles.prescriptionStartDate" name="prescriptionStartDate"
              onChange={onChange} value={prescriptionStartDate}
              max={prescriptionEndDate}
            />
          </Row.Cell>
          <Row.Cell>
            <Input type="date" label="titles.prescriptionEndDate" name="prescriptionEndDate"
              onChange={onChange} value={prescriptionEndDate}
                   min={prescriptionStartDate}
            />
          </Row.Cell>
        </Row>
        {monitors.map((monitor, index) => (
          <Row key={index}>
            <Row.Cell>
              <Select label="titles.monitorID" name="monitorID" value={monitor.monitorID}
                      onChange={(event) => patient.setMonitorFields(event, medicationIndex, index)}>
                <option value=""/>
                <Select.Options choices={allMonitors} disabledChoices={assignedMonitors}/>
              </Select>
            </Row.Cell>
            <Row.Cell>
              <Input type="date" label="titles.monitorStartDate"
                     name="monitorStartDate" value={monitor.monitorStartDate}
                     min={prescriptionStartDate}
                     max={monitor.monitorEndDate}
                     onChange={(event) => patient.setMonitorFields(event, medicationIndex, index)}
              />
            </Row.Cell>
            <Row.Cell>
              <Input type="date" label="titles.monitorEndDate"
                     name="monitorEndDate" value={monitor.monitorEndDate}
                     min={monitor.monitorStartDate}
                     max={prescriptionEndDate}
                     onChange={(event) => patient.setMonitorFields(event, medicationIndex, index)}
              />
            </Row.Cell>
            <DeleteMonitorButton onClick={(event) => patient.removeMonitor(event, medicationIndex, index)}>Delete Monitor</DeleteMonitorButton>
          </Row>
        ))}
        {!hideMonitor && <Row>
          <AddMonitorButton onClick={(event) => patient.addMonitor(event, medicationIndex)}>
            <Text str="titles.addMonitor" />
          </AddMonitorButton>
        </Row>}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/MedicationForm.js